import React from "react";
import { PlayCircle, ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * VideoPlaceholder — transparent inside; blue ring border with a slow soft outer glow pulse
 * sitting BEHIND the border edge. "Coming Soon" message + bouncing arrow guiding readers
 * to the information below.
 */
export function VideoPlaceholder({
    systemName = "this system",
    className = "",
    testId = "system-video-placeholder",
}) {
    return (
        <div className={cn("flex flex-col items-center", className)}>
            {/* Wrapper hosts the outer pulsing glow */}
            <div className="relative w-full max-w-2xl">
                {/* Outer GLOW (behind the border) — pulses slowly */}
                <div
                    aria-hidden="true"
                    className="absolute -inset-1.5 rounded-[20px] pointer-events-none animate-video-glow-pulse"
                    style={{
                        background:
                            "radial-gradient(closest-side, rgba(24,139,246,0.45), rgba(24,139,246,0.06) 60%, transparent 75%)",
                        filter: "blur(10px)",
                    }}
                />
                {/* The actual video frame: TRANSPARENT inside, sharp blue border */}
                <div
                    data-testid={testId}
                    className="relative rounded-2xl border-[2.5px] border-[#188bf6] bg-transparent overflow-hidden"
                >
                    <div className="aspect-video w-full flex flex-col items-center justify-center text-[#4a5562] relative">
                        <PlayCircle
                            className="w-12 h-12 sm:w-14 sm:h-14 text-[#188bf6] drop-shadow-[0_2px_12px_rgba(24,139,246,0.35)]"
                            aria-hidden="true"
                        />
                        <p className="mt-3 inline-flex items-center gap-2 text-[10px] sm:text-[11px] font-display font-bold uppercase tracking-[0.22em] text-[#188bf6]">
                            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#188bf6] animate-pulse" />
                            Coming Soon
                        </p>
                        <p className="mt-1.5 text-xs sm:text-sm text-[#4a5562] px-6 text-center max-w-md">
                            Walkthrough video for {systemName} is on the way.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-6 inline-flex items-center gap-2 text-[12px] sm:text-sm font-display font-bold text-[#0a0b0d]">
                <span>While you wait, here's how it works</span>
                <ArrowDown
                    className="w-4 h-4 text-[#188bf6] animate-bounce"
                    aria-hidden="true"
                />
            </div>
        </div>
    );
}

export default VideoPlaceholder;
